export enum VerificationFileSizeEnum {
    SUCCESS = 'success',
    BIG = 'big',
    SMALL = 'small',
}
